// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#backdrop {
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  backdrop-filter: blur(5px);
  z-index: 99;
  opacity: 0;
  animation: animateBackdrop 500ms ease-in forwards;
}

@keyframes animateBackdrop {
  to {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/modal.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,0BAA0B;EAC1B,WAAW;EACX,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":["#backdrop {\n  background: rgba(0, 0, 0, 0.3);\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  backdrop-filter: blur(5px);\n  z-index: 99;\n  opacity: 0;\n  animation: animateBackdrop 500ms ease-in forwards;\n}\n\n@keyframes animateBackdrop {\n  to {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
